"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManufacturerEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const ManufacturerDto_1 = require("./ManufacturerDto");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class ManufacturerEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, manufacturer) {
        super();
        this._requiredFieldsSetStatus = {
            name: false,
            iconFileName: false,
            iconContentType: false,
            iconFileSize: false
        };
        this._dependencies = dependencies;
        if (manufacturer === undefined) {
            this._dto = new ManufacturerDto_1.ManufacturerDto();
        }
        else if (manufacturer instanceof ManufacturerDto_1.ManufacturerDto) {
            this._dto = new ManufacturerDto_1.ManufacturerDto(manufacturer);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (manufacturer instanceof ManufacturerEntity) {
            this._dto = new ManufacturerDto_1.ManufacturerDto(manufacturer._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new ManufacturerDto_1.ManufacturerDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getName() {
        return this._dto.name;
    }
    setName(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("name");
        this._requiredFieldsSetStatus.name = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("name", "Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("name", `Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.name) {
            return;
        }
        this._dto.name = _untrustedValue;
        this._setIsDirty(true);
    }
    getIconFileName() {
        return this._dto.iconFileName;
    }
    setIconFileName(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("iconFileName");
        this._requiredFieldsSetStatus.iconFileName = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("iconFileName", "Icon File Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("iconFileName", `Icon File Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.iconFileName) {
            return;
        }
        this._dto.iconFileName = _untrustedValue;
        this._setIsDirty(true);
    }
    getIconContentType() {
        return this._dto.iconContentType;
    }
    setIconContentType(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("iconContentType");
        this._requiredFieldsSetStatus.iconContentType = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("iconContentType", "Icon Content Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("iconContentType", `Icon Content Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.iconContentType) {
            return;
        }
        this._dto.iconContentType = _untrustedValue;
        this._setIsDirty(true);
    }
    getIconFileSize() {
        return this._dto.iconFileSize;
    }
    setIconFileSize(untrustedValue) {
        let _untrustedValue;
        this.clearError("iconFileSize");
        this._requiredFieldsSetStatus.iconFileSize = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("iconFileSize", "Icon File Size is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("iconFileSize", "Icon File Size is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.iconFileSize) {
            return;
        }
        this._dto.iconFileSize = _untrustedValue;
        this._setIsDirty(true);
    }
    getIconUpdatedAt() {
        return this._dto.iconUpdatedAt;
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    getActionBarIconFileName() {
        return this._dto.actionBarIconFileName;
    }
    setActionBarIconFileName(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("actionBarIconFileName");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("actionBarIconFileName", `Action Bar Icon File Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.actionBarIconFileName) {
            return;
        }
        this._dto.actionBarIconFileName = _untrustedValue;
        this._setIsDirty(true);
    }
    getActionBarIconContentType() {
        return this._dto.actionBarIconContentType;
    }
    setActionBarIconContentType(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("actionBarIconContentType");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("actionBarIconContentType", `Action Bar Icon Content Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.actionBarIconContentType) {
            return;
        }
        this._dto.actionBarIconContentType = _untrustedValue;
        this._setIsDirty(true);
    }
    getActionBarIconFileSize() {
        return this._dto.actionBarIconFileSize;
    }
    setActionBarIconFileSize(untrustedValue) {
        let _untrustedValue;
        this.clearError("actionBarIconFileSize");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("actionBarIconFileSize", "Action Bar Icon File Size is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.actionBarIconFileSize) {
            return;
        }
        this._dto.actionBarIconFileSize = _untrustedValue;
        this._setIsDirty(true);
    }
    getActionBarIconUpdatedAt() {
        return this._dto.actionBarIconUpdatedAt;
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.manufacturerDatastore
                    .getAsync(id, expand);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Manufacturers is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.manufacturerDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.manufacturerDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.iconUpdatedAt = dto.iconUpdatedAt;
                this._dto.actionBarIconUpdatedAt = dto.actionBarIconUpdatedAt;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Manufacturers cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.manufacturerDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.ManufacturerEntity = ManufacturerEntity;
//# sourceMappingURL=ManufacturerEntity.js.map